const apiUrl = process.env.REACT_APP_API_URL;
export const GetAlumnesTasquesByProject = async (id_group : string, id_projecte : string, sprint : number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/grups/${id_group}/tasques?sprint=${sprint}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
